import googleApi from '@/services/api/google';

const AUTH_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
const POLL_INTERVAL_MS = 3_000; // 3 seconds

export async function openGoogleAuth(onSuccess: () => void, onError?: (error: string) => void): Promise<void> {
  try {
    const url = await googleApi.getAuthUrl();

    window.open(
      url,
      'google-auth',
      'width=500,height=700,scrollbars=yes,resizable=yes',
    );

    let settled = false;

    const cleanup = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      clearInterval(pollInterval);
      window.removeEventListener('message', handler);
    };

    // Primary path: postMessage from bridge component
    const handler = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (!event.data?.type) return;

      if (event.data.type === 'google-oauth-success') {
        cleanup();
        onSuccess();
      } else if (event.data.type === 'google-oauth-error') {
        cleanup();
        onError?.(event.data.error || 'OAuth fehlgeschlagen');
      }
    };

    window.addEventListener('message', handler);

    // Fallback path: poll /api/google/status every 3s
    const pollInterval = setInterval(async () => {
      if (settled) return;
      try {
        const status = await googleApi.getStatus();
        // Erst bei NUTZBAREM Token Erfolg (EINE Definition, 2026-07-12): beim
        // Reconnect eines toten Tokens existiert die alte Zeile noch (connected=true),
        // ist aber bis storeToken() invalid — sonst faelschlich sofort Erfolg.
        if (status.connected && !status.invalid) {
          cleanup();
          onSuccess();
        }
      } catch {
        // Ignore poll errors — postMessage is the primary path
      }
    }, POLL_INTERVAL_MS);

    // Timeout cleanup after 5 minutes
    const timeout = setTimeout(() => {
      cleanup();
    }, AUTH_TIMEOUT_MS);
  } catch {
    onError?.('Google Auth URL konnte nicht abgerufen werden');
  }
}
